'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _translate = _interopRequireDefault(require("./../translate"));

var _selectionView = _interopRequireDefault(require("../selection-view"));

var _advancedFetch = _interopRequireDefault(require("./../../lib/advanced-fetch"));

var _conf = _interopRequireDefault(require("./../../conf"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var SelectionContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectionContainer, _React$Component);

  function SelectionContainer(props) {
    var _this;

    _classCallCheck(this, SelectionContainer);

    _this = _possibleConstructorReturn(this, (SelectionContainer.__proto__ || Object.getPrototypeOf(SelectionContainer)).call(this, props));
    _this.state = {
      productTypes: []
    };
    _this.save = _this.save.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SelectionContainer, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_selectionView.default, {
        productTypes: this.state.productTypes,
        save: this.save,
        resetButton: this.props.resetButton
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.load();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevPros) {
      var _this2 = this;

      if (prevPros.lng !== this.props.lng) {
        this.setState(function (prev) {
          prev.productTypes = _this2.translateProductTypes(prev.productTypes);
          return prev;
        });
      }
    }
  }, {
    key: "load",
    value: function load() {
      var _this3 = this;

      fetch(_conf.default.selectionsApiUrlTemplate(), {
        credentials: 'include'
      }).then(_advancedFetch.default).then(function (response) {
        if (response.next) {
          _this3.props.history.push(response.next);

          throw new Error('Done');
        }

        if (response.config.elements !== 'undefined') {
          _this3.setState({
            productTypes: _this3.translateProductTypes(response.config.elements)
          });
        }
      }).catch(function (err) {
        if (err.message !== 'Done') {
          if (err.status !== 404) {
            void 0;
          }
        }
      });
    }
  }, {
    key: "save",
    value: function save(data) {
      var _this4 = this;

      var body = '';

      try {
        body = JSON.stringify(data);
      } catch (err) {
        void 0;
        return;
      }

      fetch(_conf.default.selectionsApiUrlTemplate(), {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: body
      }).then(_advancedFetch.default).then(function (response) {
        if (response.next) {
          return _this4.props.history.push(response.next);
        }
      }).catch(function (err) {
        if (err.error.status !== 422) {
          void 0;
          return;
        }

        return {
          message: err.message,
          invalidFields: err.error.invalidFields
        };
      });
    }
  }, {
    key: "translateProductTypes",
    value: function translateProductTypes(productTypes) {
      if (!Array.isArray(productTypes)) {
        return [];
      }

      var t = this.props.t;
      return productTypes.map(function (productType) {
        productType.label = t(productType.key);
        return productType;
      });
    }
  }]);

  return SelectionContainer;
}(_react.default.Component);

SelectionContainer.propTypes = {
  t: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }),
  config: PropTypes.shape({
    getApiUri: PropTypes.string.isRequired,
    postApiUri: PropTypes.string.isRequired
  }),
  lng: PropTypes.string,
  resetButton: PropTypes.object
};

var _default = (0, _translate.default)(SelectionContainer);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/selection-container/index.js
// module id = 548
// module chunks = 0